import { Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import React from 'react';

import SearchPinsRow from './search_pins_row';

const ModalBodyContent = (props) => {
  const {
    dispatch,
    dragInProgress,
    editingActive,
    setDragInProgress,
    setEditingActive,
    updatedFiltersData,
  } = props;

  const displayTable = () => {
    if (updatedFiltersData.length === 0) { return null; }

    const rows = updatedFiltersData.map((searchPin, i) => (
      <SearchPinsRow
        key={searchPin.key}
        dispatch={dispatch}
        dragInProgress={dragInProgress}
        editingActive={editingActive}
        index={i}
        searchPin={searchPin}
        setDragInProgress={setDragInProgress}
        setEditingActive={setEditingActive}
        updatedFiltersData={updatedFiltersData}
      />
    ));

    return (
      <div className="search-pins-table-wrapper bf-scroll-element">
        <table className="pinned-searches-table" role="table">
          <caption className="sr-only">
            <Trans>Manage Pinned Searches</Trans>
          </caption>
          <thead>
            <tr>
              <th scope="col">
                <span className="bff-pin icon" aria-hidden />
                <Trans>Pin</Trans>
              </th>
              <th scope="col"><Trans>Featured</Trans></th>
              <th scope="col"><Trans>Query</Trans></th>
              <th scope="col" aria-label="Actions" />
              <th scope="col" aria-label="Delete" />
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    );
  };

  const displayNoResults = () => {
    if (updatedFiltersData.length > 0) { return null; }

    return (
      <h4 className="no-pinned-searches-copy">No pinned searches!</h4>
    );
  };

  return (
    <React.Fragment>
      {displayTable()}
      {displayNoResults()}
    </React.Fragment>
  );
};

ModalBodyContent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  dragInProgress: PropTypes.bool.isRequired,
  editingActive: PropTypes.bool.isRequired,
  setDragInProgress: PropTypes.func.isRequired,
  setEditingActive: PropTypes.func.isRequired,
  updatedFiltersData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ModalBodyContent;
